exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".centered-input[data-v-2d95dc24] input,.centered-label[data-v-2d95dc24]{text-align:center}", ""]);

// exports
